import { Component, OnInit, Input, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { AutomateJob, AutomateFilter } from '../../global/models';
import { Constants, EmailType, Language } from '../../global/constants';

@Component({
  selector: 'filter-popover',
  templateUrl: './filter-popover.component.html',
  styleUrls: ['./filter-popover.component.scss']
})
export class FilterPopoverComponent implements OnInit {

  @Input() job: AutomateJob;

  popovers: any[] = [];

  constructor(private constants: Constants, private domSanitizer: DomSanitizer) { }

  ngOnInit() {
    this.initView();
  }

  private initView() {
    let otherIncluded: boolean = false;
    // map filters into popover objects for rendering
    this.job.filters.forEach((filter: AutomateFilter) => {
      if (filter.include.length + filter.exclude.length > 0) {
        if (filter.type == 'email_type') {
          this.popovers.push(this.emailTypePopover(filter));
        }
        else if (filter.type == 'source') {
          this.popovers.push(this.sourcePopover(filter));
        }
        else if (!otherIncluded) {
          let p = this.otherPopover();
          p ? this.popovers.push(p) : 0;
          otherIncluded = true;
        }
      }
    });
  }

  private emailTypePopover(filter: AutomateFilter) {
    let popover: any = {
      name: 'Type',
      description: 'Email Type Filter',
      order: 1,
      include: filter.include,
      exclude: filter.exclude,
      count: filter.include.length + filter.exclude.length,
      body: ''
    };

    if (filter.include.length > 0) {
      let types: any[] = [];
      filter.include.forEach(f => {
        types.push(this.constants.emailTypes.find(et => { return et.typeName == f}).display);
      });
      popover.body = `Include: <strong>${types.join(', ')}</strong>`;
    }
    else {
      popover.body = `Include: <strong>None</strong>`;
    }
    return popover;
  }

  private sourcePopover(filter: AutomateFilter) {
    let popover: any = {
      name: 'Source',
      description: 'Source Filter',
      order: 2,
      include: filter.include,
      exclude: filter.exclude,
      count: filter.include.length + filter.exclude.length,
      body: ''
    };

    if (filter.include.length > 0) {
      popover.body = `Include: <strong>${filter.include.join(', ')}</strong>`;
    }
    else {
      popover.body = `Include: <strong>None</strong>`;
    }

    if (filter.exclude.length > 0) {
      popover.body += `<hr/>Exclude: <strong>${filter.exclude.join(', ')}</strong>`;
    }
    else {
      popover.body += `<hr/>Exclude: <strong>None</strong>`;
    }

    return popover;
  }

  private otherPopover() {
    let popover: any = {
      name: 'Other',
      description: 'Other Filters',
      order: 4,
      count: 0,
      body: ''
    };
    let first: boolean = true;

    this.job.filters.forEach((filter: AutomateFilter) => {
      if (filter.include.length + filter.exclude.length > 0) {
        if (filter.type == 'language') {
          let all: boolean = false;
          if (filter.include.length > 0) {
            let langs: any[] = [];
            filter.include.forEach(f => {
              if (f != 'all') {
                langs.push(this.constants.languages.find(l => { return l.name == f}).display);
                popover.count += filter.include.length;
              }
              else {
                all = true;
              }
            });

            if (!all) {
              if (!first) {
                popover.body += `<hr/>`;
              }
              first = false;
              popover.body += `<em>Language</em><br/>`;
              popover.body += `Include: <strong>${langs.join(', ')}</strong>`;
            }
          }
        }
        else if (filter.type == 'subject') {
          if (!first) {
            popover.body += `<hr/>`;
          }
          first = false;
          popover.body += `<em>Email Subject</em><br/>`;
          if (filter.include.length > 0) {
            popover.body += `Include: <strong>${filter.include.join(', ')}</strong>`;
            popover.count += filter.include.length;
          }
          else {
            popover.body += `Include: <strong>None</strong>`;
          }

          if (filter.exclude.length > 0) {
            popover.body += `<br/>Exclude: <strong>${filter.exclude.join(', ')}</strong>`;
            popover.count += filter.exclude.length;
          }
          else {
            popover.body += `<br/>Exclude: <strong>None</strong>`;
          }
        }
        else if (filter.type == 'body') {
          if (!first) {
            popover.body += `<hr/>`;
          }
          first = false;
          popover.body += `<em>Body</em><br/>`;
          if (filter.include.length > 0) {
            popover.body += `Include: <strong>${filter.include.join(', ')}</strong>`;
            popover.count += filter.include.length;
          }
          else {
            popover.body += `Include: <strong>None</strong>`;
          }

          if (filter.exclude.length > 0) {
            popover.body += `<br/>Exclude: <strong>${filter.exclude.join(', ')}</strong>`;
            popover.count += filter.exclude.length;
          }
          else {
            popover.body += `<br/>Exclude: <strong>None</strong>`;
          }
        }
      }
    });

    if (popover.count > 0) {
      return popover;
    }
    else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/automate/filter-popover/filter-popover.component.ts